import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import { useRealtimePollInterval } from '../../../realtime/useRealtimePollInterval';
import type { OutreachProfileDto } from '../outreachTypes';
import { useRetry } from './useRetry';

/** The poll of a building profile while the socket is down (design b2 note: 5 s). */
export const PROFILE_BUILD_POLL_MS = 5000;

/**
 * `outreach.profile.get` (frame b). `null` data: the artist has no profile yet (frame a3). While
 * the profile builds, the `outreach.profile.updated` event reads it again; the poll runs only
 * while the socket is down.
 */
export function useOutreachProfile(accountId: number) {
  const trpcAPI = useTRPCAPI();
  const pollMs = useRealtimePollInterval(PROFILE_BUILD_POLL_MS);
  const query = useTRPCQuery(
    trpcAPI.outreach.profile.get.queryOptions(
      { accountId },
      {
        retry: false,
        refetchInterval: (state) => {
          const profile = state.state.data as OutreachProfileDto | null | undefined;
          return profile?.status === 'building' && pollMs > 0 ? pollMs : false;
        },
      }
    )
  );
  const retry = useRetry(query.refetch);
  return {
    profile: query.data as OutreachProfileDto | null | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
